import { ReactNode } from "react";
import { FormGroup } from "@cofano/cck";
import { Box, IconButton, Popover } from "@mui/material";
import { LocalPhone } from "@mui/icons-material";
import usePopover from "components/hooks/usePopover";

interface PhoneContactsPopoverProps {
	contacts: Array<{
		name?: string | null;
		telephone?: string | null;
	}>;
	children: ReactNode;
}

const VoyagePhoneContactsPopover = ({ contacts, children }: PhoneContactsPopoverProps) => {
	const { popoverProps, onPopoverOpen } = usePopover({
		trigger: "click",
	});

	if (!contacts || contacts.length === 0) {
		return <>{children}</>;
	}

	return (
		<Box>
			{children}

			<IconButton size="small" onClick={onPopoverOpen} sx={{ p: 0, ml: 3 }}>
				<LocalPhone style={{ fontSize: 16 }} />
			</IconButton>

			<Popover {...popoverProps}>
				<Box p={2}>
					{contacts.map(contact => (
						<FormGroup label={contact.name}>
							<p>{contact.telephone}</p>
						</FormGroup>
					))}
				</Box>
			</Popover>
		</Box>
	);
};

export default VoyagePhoneContactsPopover;
